import React from "react";
import { FileText, Trash2 } from "lucide-react";
import FileActions from "../Common/Files/FileActions";
import useFileSource from "../Common/Files/useFileSource";
import { useTranslation } from "../../context/Internationalization";
import { Button } from "../../shadcn/components/ui/button";
import { cn } from "../../shadcn/lib/utils";

export default function UploadFilePreview({
  file,
  compact,
  onRemove,
  removeDisabled = false,
}) {
  const { t } = useTranslation();
  const { url, name, extension, type, previewKind } = useFileSource(file);
  const isPdf = extension === "pdf" || type === "application/pdf";
  return (
    <div
      className={cn(
        "flex w-full min-w-0 flex-wrap items-center gap-2",
        compact ? "flex-row" : "flex-col"
      )}
    >
      <div
        className={cn(
          "flex shrink-0 items-center justify-center [&>img]:block [&>img]:size-full [&>img]:rounded-md [&>img]:object-contain [&>video]:block [&>video]:size-full [&>video]:rounded-md [&>video]:object-contain",
          compact ? "size-16 [&>svg]:size-12" : "h-40 w-full [&>svg]:size-16"
        )}
      >
        {previewKind === "image" && url ? (
          <img src={url} alt={name} loading="lazy" />
        ) : previewKind === "video" && url ? (
          <video src={url} muted preload="metadata" />
        ) : (
          <FileText
            aria-hidden="true"
            className={isPdf ? "text-primary" : "text-muted-foreground"}
          />
        )}
      </div>
      <div className={cn("min-w-0 flex-1", !compact && "w-full")}>
        <p className="mb-1 text-sm [overflow-wrap:anywhere]">{name}</p>
        <FileActions file={file}>
          <Button
            type="button"
            variant="destructive"
            size="icon-sm"
            aria-label={t("delete")}
            onClick={onRemove}
            disabled={removeDisabled}
          >
            <Trash2 aria-hidden="true" />
          </Button>
        </FileActions>
      </div>
    </div>
  );
}
